import React from 'react';
import { withRouter, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { Row, Col, Alert, Clearfix, Button } from 'react-bootstrap';
import langs from 'langs';
import { find as _find } from 'lodash';

import { translatePage } from 'actions/CmsActions';
import { addNotification } from 'actions/NotificationsActions';
import { getSystemTypes, getSystemTypeUrl } from 'helpers/cms';
import { BASENAME } from 'js/constants';

import EntityPropsUpdater from 'component/EntityPropsUpdater';

import FormSwitchery from 'components/forms/FormSwitchery';
import FormAutocomplete from 'components/forms/FormAutocomplete';
import FormHoldingCompany from 'components/forms/FormHoldingCompany';
import FormWhiteLabelProject from 'components/forms/FormWhiteLabelProject';
import FormInput from 'components/forms/FormInput';
import FormRadio from 'components/forms/FormRadio';

class PageData extends EntityPropsUpdater {
  constructor(props) {
    super(props);

    this.state = {
      ...this.state,
      showChangeParent: false,
    };
  }

  navigatePage = pageId => {
    const { appIntl, history } = this.props;
    history.push(appIntl.urlPrefix + 'account/cms/' + pageId);
  };

  componentDidUpdate = prevProps => {
    const {
      intl: { messages },
      cmsTranslation,
      doNotify,
    } = this.props;

    if (prevProps.cmsTranslation.pending && !cmsTranslation.pending) {
      // a translation was created, navigate to edit the translated page
      doNotify(1, messages.page_translate_created);
      this.navigatePage(cmsTranslation.data.id);
    }
  };

  changeParentPage = parent => {
    this.setState({ showChangeParent: false });
    this.updateEntityMultiple(
      ['parentId', 'parentName'],
      [(parent && parent.id) || null, (parent && parent.name) || null]
    );
  };

  render() {
    const {
      intl: { messages },
      appIntl,
      entity,
      entityLoaded,
      user,
      disabled,
      inModal,
      updateOwner,
      owner,
      updateWhiteLabelProject,
    } = this.props;
    const { showChangeParent } = this.state;

    let pageViewUrl;
    if (entityLoaded) {
      if (entity.getSystemType()) {
        pageViewUrl = BASENAME + '/' + entity.getLanguage() + '/' + getSystemTypeUrl(entity.getSystemType());
      } else if (entity.getSlug()) {
        pageViewUrl = BASENAME + '/' + entity.getLanguage() + '/pages/' + entity.getSlug();
      }
    }

    const parentPageAutocomplete = entityLoaded && (
      <FormAutocomplete
        label={messages.parent_page}
        name="parent"
        value={entity.getParentId()}
        meta={entity.getParentIdMetaInformation()}
        validation={entity.getParentIdValidationResult()}
        onChange={(name, parent) => this.changeParentPage(parent)}
        returnValueObject
        autocompleteType="page"
        disabled={disabled}
        clearable
      />
    );

    return (
      <div class="clearfix">
        {entityLoaded && (
          <Row>
            <Col xs={12} md={inModal ? 12 : 6}>
              <div class="panel panel-transparent">
                <div class="panel-body">
                  <p className="form-group-title">{messages.page}</p>
                  <div class="form-group-attached">
                    <FormInput
                      label={messages.name}
                      name="name"
                      value={entity.getName()}
                      meta={entity.getNameMetaInformation()}
                      validation={entity.getNameValidationResult()}
                      onChange={this.updateEntity}
                      disabled={disabled}
                    />
                    <FormAutocomplete
                      label={messages.system_type}
                      name="systemType"
                      value={entity.getSystemType()}
                      meta={entity.getSystemTypeMetaInformation()}
                      validation={entity.getSystemTypeValidationResult()}
                      onChange={this.updateEntity}
                      disabled={disabled}
                      options={getSystemTypes(messages)}
                    />
                    <FormHoldingCompany
                      onChange={updateOwner}
                      selectedClient={owner && owner.username}
                      disabled={disabled}
                      label={messages.company}
                    />
                    <FormWhiteLabelProject
                      onChange={updateWhiteLabelProject}
                      selectedWhiteLabelProject={entity.getWhiteLabelProject()}
                      disabled={disabled}
                    />
                    {entity.getParentId() ? (
                      <>
                        {showChangeParent ? (
                          parentPageAutocomplete
                        ) : (
                          <div class="form-group form-group-default padding-10">
                            <label>{messages.parent_page}</label>
                            <Link to={appIntl.urlPrefix + 'account/cms/' + entity.getParentId()}>
                              {entity.getParentName()}
                            </Link>
                            <Button
                              class="m-l-10 btn-rounded"
                              bsSize="xs"
                              onClick={() => this.setState({ showChangeParent: true })}
                            >
                              {messages.change_parent}
                            </Button>
                          </div>
                        )}
                      </>
                    ) : (
                      parentPageAutocomplete
                    )}
                  </div>

                  <p class="m-t-10 form-group-title">{messages.main_menu}</p>
                  <div class="form-group-attached">
                    <FormRadio
                      name="menuBackground"
                      label={messages.menu_transparent}
                      value={entity.getMenuBackground()}
                      meta={entity.getMenuBackgroundMetaInformation()}
                      validation={entity.getMenuBackgroundValidationResult()}
                      onChange={this.updateEntity}
                      disabled={disabled}
                      options={[{ label: messages.yes, value: 'transparent' }, { label: messages.no, value: '' }]}
                    />
                    <FormRadio
                      name="menuVersion"
                      label={messages.menu_version}
                      value={entity.getMenuVersion()}
                      meta={entity.getMenuVersionMetaInformation()}
                      validation={entity.getMenuVersionValidationResult()}
                      onChange={this.updateEntity}
                      disabled={disabled}
                      options={[
                        { label: messages.menu_light, value: 'light' },
                        { label: messages.menu_dark, value: 'dark' },
                      ]}
                    />
                    <FormRadio
                      name="logoVersion"
                      label={messages.logo_version}
                      value={entity.getLogoVersion()}
                      meta={entity.getLogoVersionMetaInformation()}
                      validation={entity.getLogoVersionValidationResult()}
                      onChange={this.updateEntity}
                      disabled={disabled}
                      options={[
                        { label: messages.logo_default, value: 'default' },
                        { label: messages.logo_scroll, value: 'scroll' },
                      ]}
                    />
                  </div>

                  <p class="m-t-10 form-group-title">{messages.footer}</p>
                  <div class="form-group-attached">
                    <div class="form-group form-group-default padding-10">
                      <FormSwitchery
                        name="hideFooter"
                        label={messages.hide_footer}
                        checked={entity.getHideFooter()}
                        value
                        onChange={this.updateEntity}
                        disabled={disabled}
                      />
                    </div>
                  </div>

                  {!!pageViewUrl && (
                    <div class="m-t-15">
                      <Alert bsStyle="info">
                        {messages.link_to_page}:{' '}
                        <a href={pageViewUrl} target="_blank">
                          {pageViewUrl}
                        </a>
                      </Alert>
                    </div>
                  )}
                </div>
              </div>
            </Col>

            <Col xs={12} md={inModal ? 12 : 6}>
              <div class="panel panel-transparent">
                <div class="panel-body">
                  <p className="form-group-title">{messages.status}</p>
                  <div class="form-group-attached">
                    <div class="form-group form-group-default padding-10">
                      <FormSwitchery
                        name="isPublished"
                        label={messages.is_published}
                        checked={entity.getIsPublished()}
                        value
                        onChange={this.updateEntity}
                      />
                    </div>
                    {!entity.getIsPublished() && (
                      <FormInput
                        label={messages.forward_url}
                        name="forwardUrl"
                        value={entity.getForwardUrl()}
                        meta={entity.getForwardUrlMetaInformation()}
                        validation={entity.getForwardUrlValidationResult()}
                        onChange={this.updateEntity}
                        disabled={disabled}
                      />
                    )}
                  </div>

                  {user.project_lang.project_languages.length > 1 && (
                    <div>
                      <p class="m-t-10 form-group-title">{messages.language}</p>
                      <div class="form-group-attached">
                        {user.project_lang.project_languages.map(language => {
                          const langVersion = _find(entity.getLangVersions(), ['language', language]);

                          if (
                            !langVersion ||
                            entity.getLanguage() === language ||
                            langVersion.getPageId() === entity.getId()
                          ) {
                            return (
                              <div class="radio radio-success" key={language}>
                                <input
                                  disabled={disabled}
                                  id={'cmsLanguage' + language}
                                  name="language"
                                  type="radio"
                                  value={language}
                                  checked={entity.getLanguage() === language}
                                  onChange={e => this.updateEntity('language', e.target.value)}
                                />
                                <label for={'cmsLanguage' + language}>{langs.where('1', language).local}</label>
                              </div>
                            );
                          }

                          return null;
                        })}
                      </div>

                      <p class="m-t-10">{messages.translations}</p>
                      <div class="">
                        {entity.getLangVersions().length === 1 && (
                          <Alert bsStyle="info">{messages.page_has_no_translations}</Alert>
                        )}

                        {user.project_lang.project_languages.map(language => {
                          if (language !== entity.getLanguage()) {
                            const langVersion = _find(entity.getLangVersions(), ['language', language]);

                            return langVersion ? (
                              <div key={language} class="m-b-5 padding-10 bg-master-lightest">
                                <i class="m-r-10 fa-fw fa fa-check text-success" />
                                {langs.where('1', language).local}
                                <div class="pull-right">
                                  <Button
                                    class="btn-rounded"
                                    bsSize="xsmall"
                                    onClick={() => this.navigatePage(langVersion.getPageId())}
                                  >
                                    {messages.edit}
                                  </Button>
                                </div>
                                <Clearfix />
                              </div>
                            ) : (
                              <div key={language} class="m-b-5 padding-10 bg-master-lightest">
                                <i class="m-r-10 fa-fw fa fa-times text-warning" />
                                {langs.where('1', language).local}
                                <div class="pull-right">
                                  <Button
                                    class="btn-rounded"
                                    bsSize="xsmall"
                                    onClick={() => this.props.doTranslate(entity.getId(), language)}
                                  >
                                    {messages.translate}
                                  </Button>
                                </div>
                                <Clearfix />
                              </div>
                            );
                          }

                          return null;
                        })}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </Col>
          </Row>
        )}
      </div>
    );
  }
}
PageData.defaultProps = {
  inModal: false,
};

const mapStateToProps = state => {
  return {
    appIntl: state.intl,
    webApp: state.webApp,
    user: state.login.user,
    cmsTranslation: state.cms.translatePage,
  };
};
const mapDispatchToProps = dispatch => {
  return {
    doNotify: (code, text) => {
      dispatch(addNotification(code, text));
    },
    doTranslate: (pageId, language) => {
      dispatch(translatePage(pageId, language));
    },
  };
};

export default withRouter(
  injectIntl(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(PageData)
  )
);
